var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencil(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pencil_svg__clip0_31_6)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.784 59.289L5.93 80.244a5.265 5.265 0 005.111 6.39c.365.039.734.039 1.099 0l21.083-4.856 40.48-40.327-22.59-22.54L10.783 59.29zM86.429 21.262L71.35 6.184a5.29 5.29 0 00-7.462 0l-8.382 8.383 22.565 22.565 8.382-8.382a5.29 5.29 0 00-.025-7.488z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pencil_svg__clip0_31_6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h92v92H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default ForwardRef;